module.exports = __webpack_public_path__ + "static/media/Cleffa_gaussian2.f0eff327.png";